/**
 * musePanel — what the visitor's sign-in panel and the return from it agree on (plan
 * `2026_11_02_ovid_visitor_open.md` § Decided 4 and 6), isomorphic: the panel (client) writes the choice onto the
 * address the sign-in returns to, and the home loader (server) reads it back, through the same two functions.
 */
import {withParam} from '@core/billing/checkoutReturn'

/** The query parameter that carries the muse a visitor chose before the card, as `basis` carries the picture. */
export const MUSE_CHOICE_PARAM = 'muse'

/** A muse key as the roster writes it: lowercase words joined by hyphens. The server still checks it against the
 *  registry; this only keeps what is read off an address to the shape a key has. */
const MUSE_KEY = /^[a-z][a-z0-9-]{0,63}$/

/** `address` carrying the chosen muse; the address itself when none is chosen. */
export function withMuseChoice(address: string, slug: string | null): string {
    return slug ? withParam(address, MUSE_CHOICE_PARAM, slug) : address
}

/** The muse an address brings back, or null when it names none or names something that is not a key. */
export function readMuseChoice(search: string): string | null {
    const value = new URLSearchParams(search).get(MUSE_CHOICE_PARAM)
    return value !== null && MUSE_KEY.test(value) ? value : null
}

/** The panel's one added line, shown only while a muse is chosen. */
export const chosenLine = (name: string): string => `${name} stays chosen when you come back.`

/** The line said once on the wall after the return, when the choice became the account's muse. */
export const arrivalLine = (name: string): string => `${name} is chosen. Render makes your first picture with her.`
